// A streamed upload keeps long AI imports connected while reporting actual stages.
export async function readImportResponse(response, onProgress) {
  if (!response.headers?.get('content-type')?.includes('text/event-stream')) {
    const result = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(result.error || result.message || 'Import failed');
    return result;
  }
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let pending = '';
  let result;
  try {
    while (true) {
      const { value, done } = await reader.read();
      pending += decoder.decode(value, { stream: !done }).replace(/\r\n/g, '\n');
      let end;
      while ((end = pending.indexOf('\n\n')) >= 0) {
        const frame = pending.slice(0, end);
        pending = pending.slice(end + 2);
        const type = frame.match(/^event: (.+)$/m)?.[1];
        const data = frame.split('\n').filter(line => line.startsWith('data: ')).map(line => line.slice(6)).join('\n');
        if (!data) continue;
        const payload = JSON.parse(data);
        if (type === 'progress') onProgress(payload);
        if (type === 'result') result = payload;
        if (type === 'error') throw new Error(payload.error || 'Import failed');
      }
      if (done) break;
    }
    if (!result) throw new Error('Connection interrupted before import completed. Check the template list before retrying.');
    return result;
  } finally { reader.releaseLock(); }
}
